import styled from 'styled-components';
import { createGetFromLocalTheme } from '@dbh/styled-helpers';
import { THEME_KEY_FORM_GROUP } from '@dbh/form-group-theme';

const getFromLocalTheme=createGetFromLocalTheme(["theme",THEME_KEY_FORM_GROUP]);var getFromLocalTheme$1 = getFromLocalTheme;

const FormGroup=/*#__PURE__*/styled.div.withConfig({componentId:"sc-1ve4fqv-0"})(["display:",";flex-direction:",";margin:",";"],getFromLocalTheme$1("display"),getFromLocalTheme$1("flexDirection"),getFromLocalTheme$1("margin"));FormGroup.displayName="FormGroup";

export { FormGroup as default };
